const USER_TYPE =
    Object.freeze(
        {
            PROFESSIONAL: 0,
            AMATEUR: 1,
        }
    );

export default USER_TYPE;
